import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { SendPostRequest } from '../../http';
import WrapperVisionMissionValue from './WrapperVisionMissionValue';

const ClassicWhoWeAre = ({ hostpitalAbout }) => {

  const [homeIntroData, setHomeIntroData] = useState({});
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    getHomeIntroData();
  }, []);

  const getHomeIntroData = async () => {
    const response = await SendPostRequest("content/home");
    setHomeIntroData(response?.data);
  };
  return (
    // <div className="section-about py-5">
    //   <div className="container">
    //     {/* Row */}
    //     <div className="row d-flex align-items-center">
    //       {/* Col */}
    //       <div className="col-lg-6 pad-md-bottom-30 pe-lg-5">
    //         {/* about wrap */}
    //         <div className="about-wrap relative">
    //           <div className="about-wrap-inner">
    //             {/* about details */}
    //             <div className="about-wrap-details">
    //               {/* about button */}
    //               <div className="text-center">
    //                 <div className="about-img">
    //                   <img 
    //                     src="/assets/images/about-us/about-5.jpg" 
    //                     className="tr-radius" 
    //                     alt="about-img" 
    //                   />
    //                 </div>
    //                 {/* .col */}
    //               </div>
    //             </div>
    //             {/* about details End*/}
    //           </div>
    //           <div className="counter-wrapper counter-style-2 broken-style mb-4 mb-lg-0 animated fadeInDown visible" >
    //             <div className="counter-value text-center">
    //               <h2 className="mb-1">
    //                 <span className="counter-up" data-count="32">0</span>
    //                 <span className="counter-suffix">K</span>
    //               </h2>
    //             </div>
    //             <div className="counter-details text-center">
    //               <div className="counter-title">
    //                 <p className="mb-0">Projects Delivered</p>
    //               </div>
    //             </div>	
    //           </div>
    //         </div>
    //         {/* about wrap end */}
    //       </div>
    //       {/* .col */}
    //       {/* Col */}
    //       <div className="col-lg-6">
    //         <div className="title-wrap margin-bottom-20">
    //           <div className="section-title">
    //             <div className="section-title margin-bottom-40">
    //               <h2 className="title text-uppercase mb-0">
    //                 Who <span className="theme-color">We Are</span>
    //               </h2>
    //               <span className="section-border-bottom"></span>
    //             </div>
    //           </div>
    //           <div className="pad-top-5">
    //             <p className="margin-bottom-15">
    //               There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum.
    //             </p>
    //           </div>
    //         </div>
    //         <div className="feature-box-wrap quote-style mb-3">
    //           <div className="feature-box-details">
    //             {/* Media */}
    //             <div className="media">
    //               <div className="quote-icon align-self-center me-4">
    //                 <span className="ti-quote-right theme-color"></span>
    //               </div>
    //               <div className="media-body">
    //                 <div className="quote-content">
    //                   <p className="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
    //                 </div>
    //               </div>												
    //             </div>
    //             {/* Media */}
    //           </div>
    //         </div>
    //         <p className="margin-bottom-30">
    //           Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis.
    //         </p>
    //         {/* <div className="button">
    //           <a href="/about-us" className="btn btn-default">Read More</a>
    //         </div>																	 */}
    //       </div>
    //       {/* Col */}
    //     </div>
    //     {/* Row */}
    //   </div>
    //   {/* Container */}
    // </div>
    <div className="container">
      <div className="row my-3 align-items-stretch">

        {/* ===== TOP SECTION (Video + Intro Text) ===== */}
        {homeIntroData &&
          (homeIntroData?.video_link || homeIntroData?.short_summary) && (
            <>
              <div className="col-lg-6 col-md-12 col-12 pt-5 order-2 order-lg-1 classic-who-we-are">
                <div
                  className="about-vedio-frame w-100"
                  dangerouslySetInnerHTML={{
                    __html: homeIntroData?.video_link?.replace(
                      /src="([^"]+)"/,
                      (match, p1) => {
                        const newUrl = new URL(p1);
                        newUrl.searchParams.set("autoplay", "1");
                        newUrl.searchParams.set("rel", "0");
                        newUrl.searchParams.set("mute", "1");
                        return `src="${newUrl.toString()}"`;
                      }
                    ),
                  }}
                />
              </div>

              <div className="col-lg-6 col-md-12 col-12 pt-5 order-1 order-lg-2">
                <div className="title-wrap relative mb-3">
                  <div className="section-title margin-bottom-25">
                    <h2 className="section-title mb-0 text-uppercase">
                      {homeIntroData?.main_heading}
                    </h2>
                    <span className="section-border-bottom"></span>
                  </div>
                  <div className="pad-top-15">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: homeIntroData?.short_summary,
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

      </div>

      {/* ===== ALWAYS LAST: SHORT DETAIL PARAGRAPH ===== */}
      {hostpitalAbout?.about_short_heading &&
        hostpitalAbout?.about_short_description && (
          <div className="row mt-5">
            <div className="col-12">
              <div className="title-wrap text-center">
                <div className="section-title mb-4">
                  <h2 className="title text-uppercase mb-0">
                    {hostpitalAbout.about_short_heading}
                  </h2>
                  <span className="section-border-bottom center"></span>
                </div>

                <p
                  className="about-intro-data-descr mb-0"
                  dangerouslySetInnerHTML={{
                    __html: hostpitalAbout.about_short_description,
                  }}
                />
              </div>
            </div>
          </div>
        )}
    </div>

  );
};

export default ClassicWhoWeAre;